<template>
	<div class="artwork-filter">
		<select class="category-navigation-list" v-model="selectedReviewState" @change="onChange">
			<option v-for="item in reviewStates" :value="item.value" :key="item.value">
				{{ item.name }}
			</option>
		</select>
	</div>
</template>

<script>
export default {
	emits: ['change'],

	data() {
		return {
			isLoading: false,
			isError: false,
			reviewStates: [
				{'value': '', 'name': 'All Artworks'},
				{'value': 'waiting', 'name': 'Waiting for Review'},
				{'value': 'my-shortlist', 'name': 'My Shortlist'},
				{'value': 'all-shortlist', 'name': 'All Shortlists'},
				{'value': 'my-finalists', 'name': 'My Finalists'},
				{'value': 'all-finalists', 'name': 'All Finalists'}
			],

			selectedReviewState: '',
		}
	},
	// mounted() {
	// },

	methods: {
		onChange(event) {
			event.stopImmediatePropagation();
			this.$emit('change', this.selectedReviewState);
		}
	}
}

</script>